import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import helper from "../helper/index.js";

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        API_URL: process.env.VUE_APP_API_URL,
        API_URL_REVAMP: process.env.VUE_APP_API_IPERMIT_REVAMP,
        dateFormat: 'YYYY-MM-DD',
        token: localStorage.getItem('token') || '',
        tokenIsafe: localStorage.getItem('tokenIsafe') || '',
        appVersion: localStorage.getItem('appVersion') || '',
        API_URL_ISAFE: process.env.VUE_APP_API_URL_ISAFE,
        showDrawer: false,
        loadingData: false,
        openModalNot: null,
        userId: 1,
        dataUsers: JSON.parse(localStorage.getItem('user')) || {},
        dataJobTypes: {},
        dataRequests: [],
        dataQuestions: [],
        formCodeQuestions: "",
        dataEditQuestion: [],
        formCodeEditQuestion: '',
        formIdQuestion: "",
        PayloadQuestion: "",
        formIdEditQuestion: "",
        dataReqApproval: [],
        currentForm: {},
        dataEditRequest: {},
        temp: null,
        locations: [],
        myPermit: [],
        myAttachment: [],
        myFilteredAttachment: [],
        listPermit: [],
        listPermitByIpNo: [],
        myApprovalPermit: [],
        newMyApprovalPermit: [],
        newMyApprovalPermitv2: [],
        newMyPermit: [],
        loader: false,
        shortenUrl: null,
        permitHolder: [],
        registeredUser: [],
        filteredCarInfos: [],
        userList: [],
        dataEditUser: {},
        carInfos: [],
        carType: [],
        listDataVisitor: {},
        selectedAttachment: [],
        waskatData: "",
        sharing: {
            title: 'Shared from iPermit System',
            description: 'to save the trees, I would rather to share this digital document than print. Thanks.',
        },
        networks: [
            { network: 'email', name: 'Email', icon: 'far fah fa-lg fa-envelope' },
            { network: 'whatsapp', name: 'Whatsapp', icon: 'fab fah fa-lg fa-whatsapp' }
        ],
        visitorRules: {
            rules: value => !value || value.size < 10000000 || 'Ukuran file harus dibawah 10 MB!',
            ktpLength: value => value.length <= 16 || 'Max 16 characters',
            required: value => !!value || 'Required.',
            counter: value => value.length <= 20 || 'Max 20 characters',
            email: value => {
                const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                return pattern.test(value) || 'Invalid e-mail.'
            },
            phone: value => {
                const pattern = /^\+62{1}[0-9]{3,25}$|^\66\62{1}[0-9]{3,25}$|^\60\70{1}[0-9]{3,25}$/
                return pattern.test(value) || 'Invalid Phone Number Format'
            },
            ktp: value => {
                const pattern = /^[0-9]*$/
                return pattern.test(value) || 'Only Numbers are allowed.'
            }
        },
        snackbarMessage: '',
        snackbarColor: '',
        printEwaskatList: [],
        extendEwaskatList: [],
        modalNeedSetPjs: (localStorage.getItem('needSetPjs') === 'true') || false,
    },
    mutations: {
        toggleDrawer(state) {
            state.showDrawer = !state.showDrawer;
        },
        toggleLoading(state) {
            state.loadingData = !state.loadingData;
        },
        changeFormType(state, n) {
            Vue.set(state.currentForm, 'type', n);
        },
        temporaryData(state, n) {
            state.temp = n;
        },
        authSetIsafeToken(state, token) {
            state.tokenIsafe = token;
        },
        authClearIsafeToken(state) {
            state.tokenIsafe = '';
        },
        authSetAppVersion(state, token) {
            state.appVersion = token;
        },
        authClearAppVersion(state) {
            state.appVersion = '';
        },
        authSetToken(state, token) {
            state.token = token;
        },
        authClearToken(state) {
            state.token = '';
        },
        authSetUserData(state, n) {
            state.dataUsers = n;
        },
        authClearUserData(state) {
            state.dataUsers = {};
        },
        setDataReport(state, n) {
            state.dataReport = n;
        },
        loader(state, payload) {
            state.loader = payload;
        },
        setAppVersion(state, payload) {
            state.openModalNot = payload;
        },
        setSelectedAttachment(state, payload) {
            state.selectedAttachment = payload;
        },
        showMessage(state, payload) {
            state.snackbarMessage = payload.message,
                state.snackbarColor = payload.color
        }
    },
    actions: {
        fetchDataUsers({ state, commit }) {
            commit('toggleLoading');
            axios.get(`${state.API_URL}/api/users/${state.userId}`).then(res => {
                commit('toggleLoading');
                commit('authSetUserData', res.data);
            });
        },
        fetchDataJobTypes({ state, commit }) {
            commit('toggleLoading');
            axios.get(`${state.API_URL}/form/jobTypes`).then(res => {
                commit('toggleLoading');
                state.dataJobTypes = res.data.data.map(data => data.type);
            });
        },
        fetchDataRequests({ state, commit }) {
            commit('toggleLoading');
            axios.get(`${state.API_URL}/api/requests?_id=${state.dataUsers._id}`, { headers: { "Authorization": `Bearer ${state.token}` } }).then(res => {
                commit('toggleLoading');
                state.dataRequests = res.data;
            })
        },
        fetchDataQuestions({ state, commit }, payload) {
            commit('toggleLoading');
            state.formIdQuestion = payload._id
            state.PayloadQuestion = payload
            axios.get(`${state.API_URL}/v1/requests/get-questions?formCode=${payload.ipForm}`, { headers: { "Authorization": `Bearer ${state.token}` } })
                .then(res => {
                    commit('toggleLoading');
                    state.dataQuestions = res.data[0].questions;
                    state.formCodeQuestions = res.data[0].formCode
                })
        },
        fetchEditQuestions({ state, commit }, payload) {
            commit('toggleLoading');
            state.dataEditQuestion = payload.ipPengesahan
            state.formIdEditQuestion = payload._id
            state.formCodeEditQuestion = payload.ipForm
        },
        dataMyVisitor({ state, commit }, payload) {
            commit('toggleLoading');
            state.listDataVisitor = payload
        },
        fetchDataApproval({ state, commit }) {
            commit('toggleLoading');
            axios({
                method: "get",
                url: `${state.API_URL}/api/approval/requests/${state.dataUsers._id}`,
                headers: { "Authorization": `Bearer ${state.token}` },
                auth: {
                    username: 'ipermit',
                    password: 'Ang3lT3n4n!#'
                }
            }).then(res => {
                commit('toggleLoading');
                state.dataReqApproval = res.data;
            })
        },
        fetchDataEditRequests({ state, commit }, id) {
            commit('toggleLoading');
            axios.get(`${state.API_URL}/v1/requests/getById/${id}`, { headers: { "Authorization": `Bearer ${state.token}` } }).then(res => {
                commit('toggleLoading');
                state.dataEditRequest = res.data[0];
            });
        },
        fetchDataEditAttachments({ state, commit }, id) {
            commit('toggleLoading');
            axios.get(`${state.API_URL}/v1/requests/getAttachmentById/${id}`, { headers: { "Authorization": `Bearer ${state.token}` } }).then(res => {
                commit('toggleLoading');
                state.dataEditRequest = res.data;
            });
        },
        login({ state, commit }, creds) {
            commit('toggleLoading');
            return new Promise((resolve, reject) => {
                const timestamp = helper.formatDate(new Date());
                const device = navigator.userAgent;
                const loginData = {
                    ...creds,
                    timestamp,
                    device
                };
                axios.post(`${state.API_URL}/login`, loginData).then(resp => {
                    if (resp.data.message) return reject(resp.data.message);
                    let { token, user, tokenIsafe, appVersion, needSetLeaveUser } = resp.data;
                    localStorage.setItem('token', token);
                    localStorage.setItem('tokenIsafe', tokenIsafe);
                    localStorage.setItem('appVersion', appVersion);
                    localStorage.setItem('user', JSON.stringify(user));
                    localStorage.setItem('needSetPjs', needSetLeaveUser);
                    commit('authSetToken', token);
                    commit('authSetIsafeToken', tokenIsafe);
                    commit('authSetAppVersion', appVersion);
                    commit('authSetUserData', user);
                    state.modalNeedSetPjs = needSetLeaveUser;
                    resolve(user);
                }).catch(err => {
                    reject(err);
                }).finally(() => {
                    state.loader = false;
                    commit('toggleLoading');
                })
            })
        },
        logout({ state, commit }) {
            return new Promise((resolve,) => {
                commit('authClearToken');
                commit('authClearIsafeToken');
                commit('authClearAppVersion');
                commit('authClearUserData');
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                localStorage.removeItem('appVersion');
                localStorage.removeItem('tokenIsafe');
                localStorage.removeItem('needSetPjs');
                state.modalNeedSetPjs = false;
                resolve();
            })
        },
        fetchLocations({ state, commit }) {
            try {
                commit('toggleLoading');
                let endpointloc = `${state.API_URL}/form/getlocations`;
                axios.get(endpointloc).then((res) => {
                    commit('toggleLoading');
                    state.locations = res.data;
                });
            } catch (e) {
                state.locations = [];
            }
        },
        fetchCarType({ state, commit }) {
            try {
                commit('toggleLoading');
                let endpointloc = `${state.API_URL}/form/getCarType`;
                axios.get(endpointloc, { headers: { Authorization: `Bearer ${state.tokenIsafe}` } }).then((res) => {
                    state.carType = res.data.data;
                    commit('toggleLoading');
                });
            } catch (e) {
                state.carType = [];
            }
        },
        fetchCarInfos({ state, commit }) {
            try {
                commit('toggleLoading');
                let endpointloc = `${state.API_URL}/form/getCarInfos`;
                axios.get(endpointloc, { headers: { Authorization: `Bearer ${state.tokenIsafe}` } }).then((res) => {
                    state.carInfos = res.data.data;
                    commit('toggleLoading');
                });
            } catch (e) {
                state.carInfos = [];
            }
        },
        fetchMyPermit({ state, commit }) {
            commit('toggleLoading');
            axios.get(`${state.API_URL}/v1/requests?email=${state.dataUsers.email}`, { headers: { "Authorization": `Bearer ${state.token}` } }).then((res) => {
                commit('toggleLoading');
                state.myPermit = res.data;
            });
        },
        fetchMyAttachment({ state, commit }) {
            commit('toggleLoading');
            axios.get(`${state.API_URL}/v1/requests/getPermitAttachment?email=${state.dataUsers.email}`, { headers: { "Authorization": `Bearer ${state.token}` } }).then((res) => {
                commit('toggleLoading');
                state.myAttachment = res.data;
            }).catch((error) => {
                console.log(error);
                state.loader = false;
            });
        },
        fetchMyAttachmentToAttach({ state, commit }, ipNo) {
            commit('toggleLoading');
            axios.get(`${state.API_URL}/v1/requests/getPermitAttachment?email=${state.dataUsers.email}&toAttach=1&ipNo=${ipNo}`, { headers: { "Authorization": `Bearer ${state.token}` } }).then((res) => {
                commit('toggleLoading');
                state.myFilteredAttachment = res.data;
            }).catch((error) => {
                console.log(error);
                state.loader = false;
            });
        },
        async fetchMyAttachmentApproval({ state, commit }) {
            try {
                commit('toggleLoading');
                const res = await axios.get(
                    `${state.API_URL}/v1/requests/getPermitAttachment?myattachment=1&approvalId=${state.dataUsers.nik}`,
                    { headers: { "Authorization": `Bearer ${state.token}` } }
                );
                commit('toggleLoading');
                state.myApprovalAttachment = res.data;
                return state.myApprovalAttachment;
            } catch (error) {
                console.log(error);
                state.loader = false;
            }
        },
        fetchListPermit({ state, commit }) {
            commit('toggleLoading');
            axios.get(
                `${state.API_URL}/v1/requests?desiredStatus=[2,3]&page=1&perPage=10`,
                {
                    headers: { "Authorization": `Bearer ${state.token}` }
                }
            ).then((res) => {
                commit('toggleLoading');
                state.listPermit = { data: res.data.data, jumlah: res.data.totalData };
            });
        },
        fetchMyApproval({ state, commit }) {
            commit('toggleLoading');
            let userLevel = JSON.stringify(state.dataUsers.group_level);
            axios.get(`${state.API_URL}/v1/requests?myapproval=1&loc=${state.dataUsers.location}&level=${userLevel}&email=${state.dataUsers.email}`, { headers: { "Authorization": `Bearer ${state.token}` } }).then((res) => {
                commit('toggleLoading');
                state.myApprovalPermit = res.data;
            });
        },
        fetchNewMyApproval({ state, commit }) {
            commit('toggleLoading');
            let userLevel = JSON.stringify(state.dataUsers.group_level);
            axios.get(`${state.API_URL}/v1/requests/myApprovalList?loc=${state.dataUsers.location}&level=${userLevel}&email=${state.dataUsers.email}&desiredStatus=[9]`, { headers: { "Authorization": `Bearer ${state.token}` } }).then((res) => {
                commit('toggleLoading');
                state.newMyApprovalPermit = res.data;
            });
        },
        async getShortenUrl({ state, commit }, payload) {
            try {
                commit('toggleLoading');
                const shortenEndPoint = `${state.API_URL}/v1/requests/shorten-sharable-url`;
                const resp = await axios.post(shortenEndPoint, {
                    "ipId": payload.ip._id,
                    "_id": payload.approvalUser.nik,
                    "email": payload.approvalUser.email,
                    "url": window.location.host,
                    ipNo: payload.ip.ipNo,
                    ipForm: payload.ip.ipForm
                },

                    { headers: { "Authorization": `Bearer ${state.token || payload.token}` } });
                commit("toggleLoading");
                state.shortenUrl = resp.data;
            } catch (error) {
                state.shortenUrl = null;
            }
        },
        async searchWaskatData({ state, commit }, payload) {
            try {
                commit('toggleLoading');
                const resp = await axios.get(`${state.API_URL}/v1/employees/findWaskatDataById`,
                    {
                        headers: {
                            "Authorization": `Bearer ${state.token}`,
                            "tokenisafe": state.tokenIsafe,
                        },
                        params: {
                            waskatId: payload.id,
                            isafeNo: payload.isafe_no,
                        }
                    }
                );
                state.waskatData = resp.data.data;
                commit('toggleLoading');
            } catch (error) {
                state.waskatData = ""
                payload = false;
                state.loadingData = false;
            } finally {
                state.loader = false;
            }
        },
        async searchPermitHolder({ state, commit }, payload) {
            try {
                commit('toggleLoading');
                const endpoint = `${state.API_URL}/v1/employees/findEmployeesName?size=${payload.size}&page=${payload.page}`;
                const resp = await axios.post(endpoint, payload,
                    {
                        headers: { "Authorization": `Bearer ${state.tokenIsafe}` }
                    }
                );
                state.permitHolder = resp.data;
                commit('toggleLoading');
            } catch (error) {
                state.permitHolder = [];
                payload = false;
                state.loadingData = false;
            } finally {
                state.loader = false;
            }
        },
        async searchRegisteredUser({ state, commit }, payload) {
            try {
                commit('toggleLoading');
                const endpoint = `${state.API_URL}/v1/employees/findRegisteredEmployees`;
                const resp = await axios.post(endpoint, payload,
                    {
                        headers: { "Authorization": `Bearer ${state.token}` }
                    }
                );
                state.registeredUser = resp;
                commit('toggleLoading');
            } catch (error) {
                state.registeredUser = [];
                payload = false;
                state.loadingData = false;
            } finally {
                state.loader = false;
            }
        },
        async searchCarInfo({ state, commit }, payload) {
            try {
                commit('toggleLoading');
                state.filteredCarInfos = state.carInfos.filter((carInfo) => {
                    const searchQuery = new RegExp(payload.query, 'i');
                    return (carInfo.no_lambung && carInfo.no_lambung.match(searchQuery)) ||
                        (carInfo.merk && carInfo.merk.match(searchQuery)) ||
                        (carInfo.series && carInfo.series.match(searchQuery)) ||
                        (carInfo.type && carInfo.type.match(searchQuery)) ||
                        (carInfo.equipment_supplier && carInfo.equipment_supplier.match(searchQuery));
                });
                commit('toggleLoading');
            } catch (error) {
                console.log(error);
                state.filteredCarInfos = [];
                payload = false;
                state.loadingData = false;
            } finally {
                state.loader = false;
            }
        },
        async fetchAllUser({ state, commit }) {
            try {
                commit('toggleLoading');
                const endpoint = `${state.API_URL}/v1/requests/get-all-user`;
                const resp = await axios.get(endpoint,
                    {
                        headers: { "Authorization": `Bearer ${state.token}` }
                    }
                );
                state.userList = resp.data.data;
                commit('toggleLoading');
            } catch (e) {
                state.userList = [];
            } finally {
                state.loader = false;
            }
        },
        async resendNotification({ state, commit }, { ipNo, visitorId }) {
            try {
                commit('toggleLoading');
                await axios.post(`${state.API_URL}/v1/requests/resend-notif-visitor`, {
                    ipNo,
                    visitorId
                }, {
                    headers: { "Authorization": `Bearer ${state.token}` }
                });
                commit('toggleLoading');
            } catch (error) {
                state.loadingData = false;
            } finally {
                state.loader = false;
            }
        },
        fetchDataEditUser({ state, commit }, email) {
            commit('toggleLoading');
            axios.get(`${state.API_URL}/v1/requests/get-user?email=${email}`, { headers: { "Authorization": `Bearer ${state.token}` } }).then(res => {
                commit('toggleLoading');
                state.dataEditUser = res.data.data;
            });
        },
        fetchNewMyApprovalv2({ state, commit }) {
            commit('toggleLoading');
            axios.get(
                `${state.API_URL}/v1/requests/myApprovalList?email=${state.dataUsers.email}&desiredStatus=[9]&page=1&perPage=10`,
                {
                    headers: { "Authorization": `Bearer ${state.token}` }
                }
            ).then(res => {
                commit('toggleLoading');
                state.newMyApprovalPermitv2 = { data: res.data.data, jumlah: res.data.totalData, desiredStatus: res.data.desiredStatus };
            });
        },
        fetchNewfetchMyPermit({ state, commit }) {
            commit('toggleLoading');
            axios.get(
                `${state.API_URL}/v1/requests/myPermitList?email=${state.dataUsers.email}&desiredStatus=[2,3]&page=1&perPage=10`,
                {
                    headers: { "Authorization": `Bearer ${state.token}` }
                }
            ).then(res => {
                commit('toggleLoading');
                state.newMyPermit = { data: res.data.data, jumlah: res.data.totalData };
            });
        },
        perubahanClosing({ state, commit }, payload) {
            commit('toggleLoading');
            return new Promise((resolve, reject) => {
                axios.post(`${state.API_URL}/v1/requests/perubahan/closing`,
                    {
                        "formId": payload.formId,
                        "ipTindakanPengendalian": payload.ipTindakanPengendalian,
                        "ipTingkatSetelahDikendalikan": {
                            "nilaiKonsekuensi": payload.nilaiKonsekuensi,
                            "kekerapan": payload.kekerapan,
                            "tingkatRisiko": payload.tingkatRisiko
                        }
                    }, {
                    headers: { Authorization: `Bearer ${state.token}` }
                }).then(res => {
                    resolve(res)
                })
                    .catch((err) => {
                        reject(err);
                    })
                    .finally(() => {
                        commit('toggleLoading');
                    })
            })
        },
        deleteFile({ state, commit }, payload) {
            commit('toggleLoading');
            return new Promise((resolve, reject) => {
                axios.post(`${state.API_URL}/v1/requests/deleteFileGCS`,
                    {
                        "uploadId": payload.uploadId,
                        "folderName": payload.folderName,
                    }, {
                    headers: { Authorization: `Bearer ${state.token}` }
                }).then(res => {
                    resolve(res)
                })
                    .catch((err) => {
                        reject(err);
                    })
                    .finally(() => {
                        commit('toggleLoading');
                    })
            })
        },
        fetchPrintEwaskatList({ state, commit }) {
            commit('toggleLoading');
            axios.get(
                `${state.API_URL}/v1/requests/listPrintEwaskat?email=${state.dataUsers.email}&page=1&perPage=10`,
                {
                    headers: { "Authorization": `Bearer ${state.token}` }
                }
            ).then(res => {
                commit('toggleLoading');
                state.printEwaskatList = { data: res.data.data, jumlah: res.data.totalData };
            });
        },
        fetchExtendEwaskatList({ state, commit }) {
            commit('toggleLoading');
            axios.get(
                `${state.API_URL}/v1/requests/waskat/extend?email=${state.dataUsers.email}&desiredStatus=[-1]&page=1&perPage=10&userId=${state.dataUsers._id}
                `,
                {
                    headers: { "Authorization": `Bearer ${state.token}` }
                }
            ).then(res => {
                commit('toggleLoading');
                state.extendEwaskatList = { data: res.data.data, jumlah: res.data.totalData, desiredStatus: res.data.desiredStatus };
            });
        },
        closeNeedSetPjs({ state }) {
            localStorage.setItem('needSetPjs', false);
            state.modalNeedSetPjs = false;
        }
    },
    getters: {
        getListVisitor: state => state.listDataVisitor,
        isAuthenticated: state => !!state.token,
        isShowingDrawer: state => state.showDrawer && !!state.token,
        showTheDrawer: state => state.showDrawer,
        // userOrganization: state => state.dataUsers.organization || [],
        userGroupLevel: state => state.dataUsers.group_level || 0,
        userLocation: state => state.dataUsers.location || 0,
        userAuth: state => {
            let userData = JSON.parse(JSON.stringify(state.dataUsers));
            // combine with leave user data if exist
            if (userData.leaveUser && userData.leaveUser.length > 0) {
                for (const i of userData.leaveUser) {
                    i.group_level.forEach(el => {
                        if (!userData.group_level.includes(el)) {
                            userData.group_level.push(el)
                        }
                    });
                    i.department.forEach(el => {
                        if (!userData.department.includes(el)) {
                            userData.department.push(el)
                        }
                    });
                    i.companies.forEach(el => {
                        if (!userData.companies.includes(el)) {
                            userData.companies.push(el)
                        }
                    });
                    i.location.forEach(el => {
                        if (!userData.location.includes(el)) {
                            userData.location.push(el)
                        }
                    });
                }
            }
            return userData;
        }
    }
});

export default store;
